import React from 'react';

import SiteFooter from '../SiteFooter/SiteFooter';

/**
 * @summary The Footer is a static component containing links that are universal to California state agencies. It contains the configurable SiteFooter element.
 * @see https://github.com/Office-of-Digital-Services/California-State-Web-Template-react/wiki/Structure#footer
 * 
 * @example
 * <Footer />
 * 
 * @returns {React.ReactElement} Returns the Footer structure element.
 */

const Footer = () => {

  return (
    <>
      <SiteFooter
        contentArr={[
          {
            title: 'EMSA Resources',
            linkArr: [
              { href: 'https://emsa.ca.gov/training_programs/', title: 'Training Programs' },
              { href: 'https://emsa.ca.gov/childcare_provider/', title: 'Child Care Providers' },
            ]
          },
          {
            title: 'Contact Information',
            linkArr: [
              { href: 'https://emsa.ca.gov/contacts', title: 'Contact EMSA' },
              { href: 'https://emsa.ca.gov/', title: 'EMSA Website' },
            ]
          },
          {
            title: 'Related Links',
            linkArr: [
              { href: 'https://www.ca.gov', title: 'CA.gov' },
              { href: 'https://www.chhs.ca.gov/', title: 'California Health & Human Services' }
            ]
          }
        ]}
      />
      {/* <!-- Global Footer --> */}
      <footer id="footer" className="global-footer">
        <div className="container">
          <div className="d-flex">
            <a href="https://ca.gov" className="cagov-logo">
              <span className="sr-only">CA.gov</span>
              <span className="ca-gov-logo-svg"></span>
            </a>
            <ul className="footer-links">
              <li>
                <a href="https://emsa.ca.gov/about_emsa/">About the EMS Authority</a>
              </li>
              <li>
                <a href="https://emsa.ca.gov/contacts/">Contact Us</a>
              </li>
              <li>
                <a href="https://emsa.ca.gov/conditions-of-use/">Conditions Of Use</a>
              </li>
              <li>
                <a href="https://emsa.ca.gov/privacy-notice/">Privacy Notice</a>
              </li>
              <li>
                <a href="https://emsa.ca.gov/disclaimer/">Disclaimer</a>
              </li>
              <li>
                <a href="https://emsa.ca.gov/accessibility/">Accessibility</a>
              </li>
            </ul>
            <ul className="socialsharer-container">
              {/* GitHub icon removed as requested */}
            </ul>
          </div>
        </div>
        {/* Copyright Statement  */}
        <div className="copyright">
          <div className="container text-right">
            Copyright 
            <span id="thisyear">
              {new Date().getFullYear()}
            </span>
            {' '}State of California
          </div>
        </div>
        <button className="return-top">
          <span className="sr-only">Back to top</span>
        </button>
      </footer>
      {/* <!-- Extra Decorative Content --> */}
      <div className="decoration-last">&nbsp;</div>
    </>
  )
}

export default Footer